<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            General Information
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <el-form :model="formGet2" size="mini" status-icon ref="formGet2" label-position="top" :rules="rulesEdit2" class="form-get">
            <el-card>
              <el-row :gutter="20" style="display: flex; align-items: stretch">
                <el-col :span="6">
                  <el-form-item prop="countryId" label="Country">
                    <el-select
                        no-data-text="no data"
                        v-model="formGet2.countryId"
                        :placeholder="$t('modal_settings_country')"
                        filterable style="width: 100%;"
                        @change="changeCountry">
                      <el-option
                          v-for="item in arrCountryId"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Organisation Started On">
                    <el-date-picker
                        v-model="formGet2.startedOn"
                        type="date"
                        :placeholder="$t('modal_settings_startedOn')"
                        value-format="dd/MM/yyyy"
                        style="width: 100%;">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="stateId" label="State">
                    <el-select
                        no-data-text="no data"
                        v-model="formGet2.stateId"
                        :placeholder="$t('modal_settings_stateProvinceCountry')"
                        filterable
                        style="width: 100%;"
                        @change="changeState">
                      <el-option
                          v-for="item in arrStateId"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Type of Organisation">
                    <el-select
                        no-data-text="no data"
                        v-model="formGet2.typeOfOrganisationId"
                        filterable
                        style="width: 100%;">
                      <el-option
                          v-for="item in arrtypeOfOrganisationId"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4" style="display: flex; flex-direction: column; justify-content: space-between;">
                  <el-form-item prop="cityId" label="City">
                    <el-select
                        no-data-text="no data"
                        v-model="formGet2.cityId"
                        :placeholder="$t('modal_settings_city')"
                        filterable
                        style="width: 100%;">
                      <el-option
                          v-for="item in arrCityId"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button style="width: 100%;" type="primary" @click="$refs.about.open()">About Our Organisation</el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="timezoneId" label="Timezone">
                    <el-select
                        no-data-text="no data"
                        v-model="formGet2.timezoneId"
                        filterable
                        style="width: 100%;">
                      <el-option
                          v-for="item in timezoneList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        <span style="float: left">{{ item.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.gmtOffsetName }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                      class="company-logo-block">
                    <el-upload
                        class="logo-uploader"
                        action=""
                        :show-file-list="false"
                        :http-request="handleLogoSuccess"
                        :before-upload="beforeLogoUpload">
                      <img v-if="formGet2.logoUrl" :src="formGet2.logoUrl" class="logo">
                      <i v-else class="el-icon-plus logo-uploader-icon"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
            <el-card style="margin-top: 20px;">
              <el-row :gutter="20">
                <el-col :span="6">
                  <h4>Contact details</h4>
                  <el-form-item prop="entityType" label="Entity Type">
                    <el-select v-model="formGet2.entityType" placeholder="Entity Type" filterable style="width: 100%;">
                      <el-option v-for="item in entityTypeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <template v-if="formGet2.entityType === 1">
                    <el-form-item prop="lastName" label="Last Name">
                      <el-input v-model="formGet2.lastName"></el-input>
                    </el-form-item>
                    <el-form-item prop="firstName" label="First Name">
                      <el-input v-model="formGet2.firstName"></el-input>
                    </el-form-item>
                    <el-form-item prop="middleName" label="Middle Name">
                      <el-input v-model="formGet2.middleName"></el-input>
                    </el-form-item>
                  </template>
                  <el-form-item prop="name" label="Entity Name">
                    <el-input v-model="formGet2.name"></el-input>
                  </el-form-item>
                  <el-form-item prop="tradingName" :label="$t('modal_settings_tradingName')">
                    <el-input v-model="formGet2.tradingName"></el-input>
                  </el-form-item>
                  <el-form-item prop="totalEmployess" :label="$t('modal_settings_totalEmployess')">
                    <el-input v-model="formGet2.totalEmployess"></el-input>
                  </el-form-item>
                  <el-form-item prop="primaryPhone" label="Main Phone No.">
                    <el-input
                        type="number"
                        v-model="formGet2.primaryPhone">
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="fax" label="Main Fax No.">
                    <el-input v-model="formGet2.fax"></el-input>
                  </el-form-item>
                  <el-form-item prop="email" label="Main Email">
                    <el-input v-model="formGet2.email"></el-input>
                  </el-form-item>
                  <el-form-item prop="website" label="Main Website">
                    <el-input v-model="formGet2.website"></el-input>
                  </el-form-item>
                  <el-form-item prop="eCommerceWebsite" label="eCommerce Website">
                    <el-input v-model="formGet2.eCommerceWebsite"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <h4>Socials</h4>
                  <el-form-item prop="linkedinPage" label="Linkedin Page">
                    <el-input v-model="formGet2.linkedinPage"></el-input>
                  </el-form-item>
                  <el-form-item prop="facebookPage" label="Facebook Page">
                    <el-input v-model="formGet2.facebookPage"></el-input>
                  </el-form-item>
                  <el-form-item prop="twitterAccount" label="Twitter Account">
                    <el-input v-model="formGet2.twitterAccount"></el-input>
                  </el-form-item>
                  <el-form-item prop="youtube" label="Youtube">
                    <el-input v-model="formGet2.youtube"></el-input>
                  </el-form-item>
                  <el-form-item prop="otherSocial" label="Other Social">
                    <el-input v-model="formGet2.otherSocial"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <h4>Organisation Main Address</h4>
                  <el-form-item prop="address" label="Address Line 1">
                    <el-input v-model="formGet2.address"></el-input>
                  </el-form-item>
                  <el-form-item prop="address2" label="Address Line 2">
                    <el-input v-model="formGet2.address2"></el-input>
                  </el-form-item>
                  <el-form-item prop="address3" label="Address Line 3">
                    <el-input v-model="formGet2.address3"></el-input>
                  </el-form-item>
                  <el-form-item prop="mainCountryId" label="Country">
                    <el-select
                        no-data-text="no data"
                        v-model="formGet2.mainCountryId"
                        :placeholder="$t('modal_settings_country')"
                        filterable style="width: 100%;"
                        @change="changeMainCountry">
                      <el-option
                          v-for="item in arrCountryId"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="mainStateId" label="State">
                    <el-select
                        no-data-text="no data"
                        v-model="formGet2.mainStateId"
                        :placeholder="$t('modal_settings_stateProvinceCountry')"
                        filterable
                        style="width: 100%;"
                        @change="changeMainState">
                      <el-option
                          v-for="item in arrMainStateId"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="mainCityId" label="City">
                    <el-select
                        no-data-text="no data"
                        v-model="formGet2.mainCityId"
                        :placeholder="$t('modal_settings_city')"
                        filterable
                        style="width: 100%;">
                      <el-option
                          v-for="item in arrMainCityId"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="mainPostCode" :label="$t('modal_post_code')">
                    <el-input v-model="formGet2.mainPostCode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <h4>Organisation Postal Address</h4>
                  <el-form-item prop="postalAddress" label="Address Line 1">
                    <el-input v-model="formGet2.postalAddress"></el-input>
                  </el-form-item>
                  <el-form-item prop="postalAddress2" label="Address Line 2">
                    <el-input v-model="formGet2.postalAddress2"></el-input>
                  </el-form-item>
                  <el-form-item prop="postalAddress3" label="Address Line 3">
                    <el-input v-model="formGet2.postalAddress3"></el-input>
                  </el-form-item>
                  <el-form-item prop="mainCountryId" label="Country">
                    <el-select
                        no-data-text="no data"
                        v-model="formGet2.postalCountryId"
                        :placeholder="$t('modal_settings_country')"
                        filterable style="width: 100%;"
                        @change="changePostalCountry">
                      <el-option
                          v-for="item in arrCountryId"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="postalStateId" label="State">
                    <el-select
                        no-data-text="no data"
                        v-model="formGet2.postalStateId"
                        :placeholder="$t('modal_settings_stateProvinceCountry')"
                        filterable
                        style="width: 100%;"
                        @change="changePostalState">
                      <el-option
                          v-for="item in arrPostalStateId"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="postalCityId" label="City">
                    <el-select
                        no-data-text="no data"
                        v-model="formGet2.postalCityId"
                        :placeholder="$t('modal_settings_city')"
                        filterable
                        style="width: 100%;">
                      <el-option
                          v-for="item in arrPostalCityId"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="postalPostCode" :label="$t('modal_post_code')">
                    <el-input v-model="formGet2.postalPostCode"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
            <el-form-item style="margin-top: 20px;">
               <el-button @click="save2('formGet2')" class="modal__btn" type="primary" plain size="small">{{$t('settings_companyAdditionalInfo_save')}}</el-button>
            </el-form-item>
          </el-form>

<!--          <el-form :model="formGet" status-icon ref="formGet" label-position="top" :rules="rulesEdit" class="form-get">-->

<!--            <div>-->
<!--              <el-row>-->
<!--                <el-col :span="12" :offset="0">-->
<!--                  <el-col :span="12">-->
<!--                      <el-form-item class="company-logo-block" label-position="top" label-width="100px" :label="$t('modal_settings_companyLogo')">-->
<!--                          <el-upload-->
<!--                                  class="logo-uploader"-->
<!--                                  action=""-->
<!--                                  :show-file-list="false"-->
<!--                                  :http-request="handleLogoSuccess"-->
<!--                                  :before-upload="beforeLogoUpload">-->
<!--                              <img v-if="formGet.logoUrl" :src="formGet.logoUrl" class="logo">-->
<!--                              <i v-else class="el-icon-plus logo-uploader-icon"></i>-->
<!--                          </el-upload>-->
<!--                      </el-form-item>-->
<!--                  </el-col>-->
<!--                </el-col>-->
<!--                <el-col :span="12" :offset="0"></el-col>-->
<!--              </el-row>-->

<!--              <el-row :gutter="40">-->
<!--                <el-col :span="12" :offset="0">-->

<!--                  <el-row :gutter="20">-->
<!--                      <el-col :span="24">-->
<!--                          <el-form-item prop="name">-->
<!--                              <el-input :label="$t('modal_settings_CompanyName')" v-model="formGet.name"></el-input>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                  </el-row>-->

<!--                  <el-row :gutter="20">-->
<!--                      <el-col :span="12">-->
<!--                          <el-form-item>-->
<!--                            <el-input v-model="formGet.taxNumber" :label="$t('modal_settings_taxNumber')"></el-input>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                      <el-col :span="12">-->
<!--                          <el-form-item prop="currencyCode">-->
<!--                              <el-select v-model="formGet.currencyCode" :placeholder="$t('modal_settings_currencyCompany')" filterable style="width: 100%;">-->
<!--                                  <el-option v-for="item in currencyList"-->
<!--                                              :key="item.id"-->
<!--                                              :label="item.code"-->
<!--                                              :value="item.id">-->
<!--                                  </el-option>-->
<!--                              </el-select>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                  </el-row>-->

<!--                  <el-row :gutter="20">-->
<!--                      <el-col :span="24">-->
<!--                          <el-form-item>-->
<!--                              <el-input :label="$t('modal_settings_tradingName')" v-model="formGet.tradingName"></el-input>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                  </el-row>-->

<!--                  <el-row :gutter="20">-->
<!--                    <el-col :span="24" :offset="0">-->
<!--                      <el-form-item>-->
<!--                        <el-date-picker-->
<!--                          v-model="formGet.financialYearStartDate"-->
<!--                          type="date"-->
<!--                          placeholder="Financial Year Start Date"-->
<!--                          value-format="dd-MM-yyyy"-->
<!--                          style="width: 100%;">-->
<!--                        </el-date-picker>-->
<!--                      </el-form-item>-->
<!--                    </el-col>-->
<!--                  </el-row>-->

<!--                  <el-row :gutter="20">-->
<!--                      <el-col :span="12">-->
<!--                          <el-form-item>-->
<!--                              <el-select v-model="formGet.businessType" :placeholder="$t('modal_settings_businessType')" filterable style="width: 100%;">-->
<!--                                  <el-option-->
<!--                                          v-for="item in businessTypeList"-->
<!--                                          :key="item.id"-->
<!--                                          :label="item.lable"-->
<!--                                          :value="item.lable">-->
<!--                                  </el-option>-->
<!--                              </el-select>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                      <el-col :span="12">-->
<!--                          <el-form-item>-->
<!--                              <el-date-picker-->
<!--                                      v-model="formGet.startedOn"-->
<!--                                      type="date"-->
<!--                                      :placeholder="$t('modal_settings_startedOn')"-->
<!--                                      value-format="dd/MM/yyyy"-->
<!--                                      style="width: 100%;">-->
<!--                              </el-date-picker>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                  </el-row>-->

<!--                  <el-row :gutter="20">-->
<!--                      <el-col :span="12">-->
<!--                          <el-form-item>-->
<!--                              <el-input :label="$t('modal_settings_website')" v-model="formGet.website"></el-input>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                      <el-col :span="12">-->
<!--                        <el-form-item prop="email" style="margin-bottom: 0;">-->
<!--                            <el-input :label="$t('modal_settings_companyEmail')" v-model="formGet.email"></el-input>-->
<!--                        </el-form-item>-->
<!--                      </el-col>-->
<!--                  </el-row>-->

<!--                  <el-row :gutter="20">-->
<!--                      <el-col :span="12">-->
<!--                          <el-form-item>-->
<!--                              <el-input type="number" :label="$t('modal_settings_phone')" v-model="formGet.primaryPhone"></el-input>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                      <el-col :span="12">-->
<!--                          <el-form-item>-->
<!--                              <el-input :label="$t('modal_settings_fax')" v-model="formGet.fax"></el-input>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                  </el-row>-->

<!--                  <el-row :gutter="20">-->
<!--                      <el-col :span="12">-->
<!--                          <el-form-item>-->
<!--                              <el-input :label="$t('modal_settings_totalEmployess')" v-model="formGet.totalEmployess"></el-input>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                      <el-col :span="12">-->

<!--                      </el-col>-->
<!--                  </el-row>-->

<!--                </el-col>-->
<!--                <el-col :span="12" :offset="0">-->

<!--                  <el-row :gutter="20">-->
<!--                      <el-col :span="12">-->
<!--                          <el-form-item>-->
<!--                          <el-switch v-model="formGet.isAddressAssigned" :active-text="$t('modal_address')"></el-switch>-->
<!--                        </el-form-item>-->
<!--                      </el-col>-->
<!--                      <el-col :span="12">-->

<!--                      </el-col>-->
<!--                  </el-row>-->

<!--                  <el-row v-if="formGet.isAddressAssigned" :gutter="20">-->
<!--                    <el-col :span="12">-->
<!--                      <el-form-item prop="countryId">-->
<!--                          <el-select no-data-text="no data" v-model="formGet.countryId" :placeholder="$t('modal_settings_country')" filterable style="width: 100%;">-->
<!--                              <el-option-->
<!--                                      v-for="item in arrCountryId"-->
<!--                                      :key="item.id"-->
<!--                                      :label="item.name"-->
<!--                                      :value="item.id"-->
<!--                                      @click.native="setStateUpdate(item.id)">-->
<!--                              </el-option>-->
<!--                          </el-select>-->
<!--                      </el-form-item>-->
<!--                    </el-col>-->
<!--                    <el-col :span="12">-->
<!--                      <el-form-item prop="stateId">-->
<!--                          <el-select no-data-text="no data" v-model="formGet.stateId" :placeholder="$t('modal_settings_stateProvinceCountry')" filterable style="width: 100%;">-->
<!--                              <el-option-->
<!--                                      v-for="item in arrStateId"-->
<!--                                      :key="item.id"-->
<!--                                      :label="item.name"-->
<!--                                      :value="item.id"-->
<!--                                      @click.native="setCityUpdate(item.id)">-->
<!--                              </el-option>-->
<!--                          </el-select>-->
<!--                      </el-form-item>-->
<!--                    </el-col>-->
<!--                  </el-row>-->

<!--                  <el-row v-if="formGet.isAddressAssigned" :gutter="20">-->
<!--                      <el-col :span="12">-->
<!--                          <el-form-item prop="cityId">-->
<!--                              <el-select no-data-text="no data" v-model="formGet.cityId" :placeholder="$t('modal_settings_city')" filterable style="width: 100%;">-->
<!--                                  <el-option-->
<!--                                          v-for="item in arrCityId"-->
<!--                                          :key="item.id"-->
<!--                                          :label="item.name"-->
<!--                                          :value="item.id">-->
<!--                                  </el-option>-->
<!--                              </el-select>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                      <el-col :span="12">-->
<!--                          <el-form-item>-->
<!--                            <el-input v-model="formGet.postCode" :label="$t('modal_post_code')"></el-input>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                  </el-row>-->

<!--                  <el-row v-if="formGet.isAddressAssigned" :gutter="20">-->
<!--                      <el-col :span="12">-->
<!--                          <el-form-item prop="address">-->
<!--                              <el-input :label="$t('modal_address_line_1')" v-model="formGet.address"></el-input>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                      <el-col :span="12">-->
<!--                          <el-form-item>-->
<!--                              <el-input :label="$t('modal_address_line_2')" v-model="formGet.address2"></el-input>-->
<!--                          </el-form-item>-->
<!--                      </el-col>-->
<!--                  </el-row>-->

<!--                  <el-row v-if="formGet.isAddressAssigned" :gutter="20">-->
<!--                    <el-col :span="12">-->
<!--                      <el-form-item>-->
<!--                        <el-input v-model="formGet.address3" :label="$t('modal_address_line_3')"></el-input>-->
<!--                      </el-form-item>-->
<!--                    </el-col>-->
<!--                    <el-col :span="12"></el-col>-->
<!--                  </el-row>-->

<!--                </el-col>-->
<!--              </el-row>-->

<!--            </div>-->

<!--            <el-form-item>-->
<!--              <el-button @click="save('formGet')" class="modal__btn" type="primary" plain size="small">{{$t('settings_companyAdditionalInfo_save')}}</el-button>-->
<!--            </el-form-item>-->
<!--          </el-form>-->

        </div>
      </div>
    </div>
    <sweet-modal blocking ref="about">
      <vue2-custom-editor
          ref="editor"
          style="margin-bottom: 20px;"
          v-model="formGet2.about">

      </vue2-custom-editor>
      <div class="modal__btn">
        <el-button v-on:click="$refs.about.close()" type="primary">{{$t('general_ok')}}</el-button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import axios from 'axios'
  import Vue2CustomEditor from "../../../components/vue-2-custom-editor";
  import { linkFormatting } from '../../../mixins/linkFormatting'
  export default {
    name: 'setting-company-general',
    components: {
      Vue2CustomEditor,
      SweetModal
    },
    computed: {},
    created() {
      this.getCompanyGeneral()
    },
    mixins: [linkFormatting],
    data() {
      return {
        currencyList: [],
        businessTypeList: [{
          id: 1,
          lable: 'Company'
        }, {
          id: 2,
          lable: 'Sole Trader'
        }, {
          id: 3,
          lable: 'Individual'
        }, {
          id: 4,
          lable: 'Charity'
        }, {
          id: 5,
          lable: 'NGO'
        }, {
          id: 6,
          lable: 'Government'
        }, {
          id: 7,
          lable: 'Sports Group'
        }, {
          id: 8,
          lable: 'Not For Profit'
        }],
        entityTypeList: [
          {id: 1, name: 'Individual'},
          {id: 2, name: 'Non Individual'},
        ],
        arrCountryId: [],
        arrStateId: [],
        arrCityId: [],
        arrMainStateId: [],
        arrMainCityId: [],
        arrPostalStateId: [],
        arrPostalCityId: [],
        arrtypeOfOrganisationId: [],
        timezoneList: [],
        // formGet: {
        //   logoUrl: '',
        //   companyId: '',
        //   name: '',
        //   organization: '',
        //   tradingName: '',
        //   financialYearStartDate: null,
        //   businessType: '',
        //   email: '',
        //   fax: '',
        //   currencyCode: '',
        //   // businessDomain: '',
        //   taxNumber: '',
        //   website: '',
        //   totalEmployess: '',
        //   startedOn: '',
        //   primaryPhone: '',
        //   // todo
        //   isAddressAssigned: false,
        //   countryId: null,
        //   stateId: null,
        //   cityId: null,
        //   address: null,
        //   address2: null,
        //   address3: null,
        //   postCode: null,
        // },
        formGet2: {
          companyId: null,
          // top block start
          countryId: null,
          stateId: null,
          cityId: null,
          startedOn: '',
          typeOfOrganisationId: null, //new
          logoUrl: '',
          timezoneId: null,
          about: '',
          // 1 column
          entityType: null,
          lastName: '',
          firstName: '',
          middleName: '',
          name: '',
          tradingName: '',
          totalEmployess: '',
          primaryPhone: '',
          fax: '',
          email: '',
          website: '',
          eCommerceWebsite: '',
          // 2 column
          linkedinPage: '',
          facebookPage: '',
          twitterAccount: '',
          youtube: '',
          otherSocial: '',
          // 3 column
          mainCountryId: null,
          mainStateId: null,
          mainCityId: null,
          mainPostCode: '',
          address: null,
          address2: null,
          address3: null,
          // 4 column
          postalCountryId: null,
          postalStateId: null,
          postalCityId: null,
          postalPostCode: '',
          postalAddress: null,
          postalAddress2: null,
          postalAddress3: null,
        },
        rulesEdit2: {
          countryId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          stateId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          cityId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          timezoneId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          name: [
            { required: true, message: this.$i18n.t('modal_settings_pleaseInputActivityCompanyName'), trigger: 'blur' },
            { min: 5, message: `${this.$i18n.t('modal_settings_lengthShouldBe')} 5`, trigger: 'blur' }
          ],
          entityType: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' },
          ],
          firstName: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' },
          ],
          lastName: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' },
          ],
          email: [
            { required: true, message: this.$i18n.t('modal_settings_pleaseInputEmailAdress'), trigger: 'blur' },
            { type: 'email', message: this.$i18n.t('modal_settings_pleaseInputCorrectEmailAddress'), trigger: 'blur' }
          ],
          // mainCountryId: [
          //   { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          // ],
          // mainStateId: [
          //   { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          // ],
          // mainCityId: [
          //   { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          // ],
          // postalCountryId: [
          //   { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          // ],
          // postalStateId: [
          //   { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          // ],
          // postalCityId: [
          //   { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          // ]
        },
        // rulesEdit: {
        //   name: [
        //       { required: true, message: this.$i18n.t('modal_settings_pleaseInputActivityCompanyName'), trigger: 'blur' },
        //       { min: 5, message: `${this.$i18n.t('modal_settings_lengthShouldBe')} 5`, trigger: 'blur' }
        //   ],
        //   email: [
        //       { required: true, message: this.$i18n.t('modal_settings_pleaseInputEmailAdress'), trigger: 'blur' },
        //       { type: 'email', message: this.$i18n.t('modal_settings_pleaseInputCorrectEmailAddress'), trigger: 'blur' }
        //   ],
        //   currencyCode: [{
        //       required: true,
        //       message: this.$i18n.t('modal_settings_currencyCodeIsRequired'),
        //       trigger: 'blur'
        //   }],
        //   categoryId: [
        //       { required: true, message: 'Please input Category', trigger: 'change' }
        //   ],
        //   classificationId: [
        //       { required: true, message: 'Please input Classification', trigger: 'change' }
        //   ],
        // },
      }
    },
    methods:{
      routerLink(page) {
        this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
      },
      async getCompanyGeneral(tabName){
        let loader = this.$loading.show();
        await this.directories();
        await this.getTimeZones()
        await this.item();
        await this.getTypeOfOrganization(this.formGet2.countryId)
        loader.hide()
      },
      directories(){
        return new Promise ((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companies/directories?companyId=${this.$route.query.companyId}&operation=update`)
            .then(response => {
              this.currencyList = response.data.currencyList
              this.arrCountryId = response.data.countryList
              resolve(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        });
      },
      async getTimeZones() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.post('/api/v1/users/directories?operation=updateMe');
        this.timezoneList = data.timezoneList
      },
      getTypeOfOrganization(countryId) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.get(`/api/v1/type-of-organisation/list?countryId=${countryId}`).then(response => {
            this.arrtypeOfOrganisationId = response.data.list
            resolve(response.data.list)
          }).catch(error => {
            console.log('An error occurred:', error);
            reject(error)
          });
        })
      },
      item(){
        return new Promise ((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companies/item?companyId=${this.$route.query.companyId}`)
            .then(async response => {
              if(response.data.item) {

                this.formGet2.companyId = response.data.item.id
                this.formGet2.name = response.data.item.name
                this.formGet2.email = response.data.item.email
                this.formGet2.currencyCode = response.data.item.currencyId
                this.formGet2.countryId = response.data.item.countryId
                this.formGet2.stateId = response.data.item.stateId
                this.formGet2.cityId = response.data.item.cityId
                this.formGet2.address = response.data.item.address
                this.formGet2.address2 = response.data.item.address2
                this.formGet2.address3 = response.data.item.address3
                this.formGet2.mainCountryId = response.data.item.mainCountryId
                this.formGet2.mainStateId = response.data.item.mainStateId
                this.formGet2.mainCityId = response.data.item.mainCityId
                this.formGet2.postalCountryId = response.data.item.postalCountryId
                this.formGet2.postalStateId = response.data.item.postalStateId
                this.formGet2.postalCityId = response.data.item.postalCityId
                this.formGet2.typeOfOrganisationId = response.data.item.typeOfOrganisationId

                let customFieldsJson = JSON.parse(response.data.item.customFieldsJson)

                this.formGet2.tradingName = customFieldsJson.tradingName
                this.formGet2.totalEmployess = customFieldsJson.totalEmployess
                this.formGet2.startedOn = customFieldsJson.startedOn
                this.formGet2.primaryPhone = customFieldsJson.primaryPhone
                this.formGet2.fax = customFieldsJson.fax
                this.formGet2.website = customFieldsJson.website
                this.formGet2.eCommerceWebsite = customFieldsJson.eCommerceWebsite
                this.formGet2.linkedinPage = customFieldsJson.linkedinPage
                this.formGet2.facebookPage = customFieldsJson.facebookPage
                this.formGet2.twitterAccount = customFieldsJson.twitterAccount
                this.formGet2.youtube = customFieldsJson.youtube
                this.formGet2.otherSocial = customFieldsJson.otherSocial
                this.formGet2.mainPostCode = customFieldsJson.mainPostCode
                this.formGet2.postalAddress = customFieldsJson.postalAddress
                this.formGet2.postalAddress2 = customFieldsJson.postalAddress2
                this.formGet2.postalAddress3 = customFieldsJson.postalAddress3
                this.formGet2.postalPostCode = customFieldsJson.postalPostCode
                this.formGet2.timezoneId = customFieldsJson.timezoneId
                this.formGet2.about = customFieldsJson.about
                this.formGet2.entityType = customFieldsJson.entityType
                this.formGet2.lastName = customFieldsJson.lastName
                this.formGet2.firstName = customFieldsJson.firstName
                this.formGet2.middleName = customFieldsJson.middleName

                this.formGet2.logoUrl = response.data.item.additionalInfo ? response.data.item.additionalInfo.avatarUrl : ''

                if (this.formGet2.countryId) {
                  this.arrStateId = await this.loadList('state', this.formGet2.countryId, 'stateList')
                }

                if (this.formGet2.stateId) {
                  this.arrCityId = await this.loadList('city', this.formGet2.stateId, 'cityList')
                }

                if (this.formGet2.mainCountryId) {
                  this.arrMainStateId = await this.loadList('state', this.formGet2.mainCountryId, 'stateList')
                }

                if (this.formGet2.mainStateId) {
                  this.arrMainCityId = await this.loadList('city', this.formGet2.mainStateId, 'cityList')
                }

                if (this.formGet2.postalCountryId) {
                  this.arrPostalStateId = await this.loadList('state', this.formGet2.postalCountryId, 'stateList')
                }

                if (this.formGet2.postalStateId) {
                  this.arrPostalCityId = await this.loadList('city', this.formGet2.postalStateId, 'cityList')
                }
                // if (this.formGet2.countryId !== null) {
                //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                //   axios
                //     .post(`/api/v1/companies/directories?operation=getStateList&countryId=${this.formGet2.countryId}`)
                //     .then(response => {
                //       console.log('---/companyVendors/directories', response.data);
                //       this.arrStateId = response.data.stateList
                //     })
                //     .catch(error => {
                //       console.log('An error occurred:', error);
                //     });
                // }
                // if (this.formGet2.stateId !== null) {
                //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                //   axios
                //     .post(`/api/v1/companies/directories?operation=getCityList&stateId=${this.formGet2.stateId}`)
                //     .then(response => {
                //       console.log('---/companyVendors/directories', response.data);
                //       this.arrCityId = response.data.cityList
                //     })
                //     .catch(error => {
                //       console.log('An error occurred:', error);
                //     });
                // }
              }
              resolve(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        });
      },
      // setStateUpdate(id) {
      //   this.formGet.stateId = null
      //   this.formGet.cityId = null
      //
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axios
      //     .post(`/api/v1/companies/directories?operation=getStateList&countryId=${id}`)
      //     .then(response => {
      //       console.log('---ADD VENDOR LIST', response.data);
      //       // this.arrCountryId = response.data.countryList
      //       this.arrStateId = response.data.stateList
      //       // this.arrCityId = response.data.cityList
      //     })
      //     .catch(error => {
      //       console.log('An error occurred:', error);
      //     });
      // },
      // setCityUpdate(id) {
      //   this.formGet.cityId = null
      //
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axios
      //     .post(`/api/v1/companies/directories?operation=getCityList&stateId=${id}`)
      //     .then(response => {
      //       console.log('---ADD VENDOR LIST', response.data);
      //       // this.arrCountryId = response.data.countryList
      //       // this.arrStateId = response.data.stateList
      //       this.arrCityId = response.data.cityList
      //     })
      //     .catch(error => {
      //       console.log('An error occurred:', error);
      //     });
      // },
      // save(form){
      //   this.$refs[form].validate((valid) => {
      //     let name = this.formGet.name
      //     if (valid) {
      //       if (this.formGet.isAddressAssigned == true) {
      //         if (this.formGet.countryId &&
      //           this.formGet.stateId &&
      //           this.formGet.cityId &&
      //           this.formGet.address) {
      //
      //             // let selectedRows = this.gridApi.getSelectedRows();
      //             if (this.formGet.website.length > 0) {
      //               if (this.formGet.website.slice(0, 7) != 'http://' && this.formGet.website.slice(0, 8) != 'https://') {
      //                 this.formGet.website = 'http://' + this.formGet.website
      //               }
      //             }
      //
      //             let customFieldsJson = {
      //               organization: this.formGet.name,
      //               tradingName: this.formGet.tradingName,
      //               businessType: this.formGet.businessType,
      //               website: this.formGet.website,
      //               totalEmployess: this.formGet.totalEmployess,
      //               startedOn: this.formGet.startedOn,
      //               primaryPhone: this.formGet.primaryPhone,
      //               fax: this.formGet.fax,
      //             }
      //
      //             customFieldsJson = JSON.stringify(customFieldsJson)
      //
      //             let data = {
      //               avatarUrl: this.formGet.logoUrl,
      //               name: this.formGet.name,
      //               email: this.formGet.email,
      //               currencyId: this.formGet.currencyCode,
      //               customFieldsJson: customFieldsJson,
      //               countryId: this.formGet.countryId,
      //               stateId: this.formGet.stateId,
      //               cityId: this.formGet.cityId,
      //               address: this.formGet.address,
      //               address2: this.formGet.address2,
      //               address3: this.formGet.address3,
      //               postCode: this.formGet.postCode,
      //               isAddressAssigned: this.formGet.isAddressAssigned,
      //               taxNumber: this.formGet.taxNumber,
      //               financialYearStartDate: this.formGet.financialYearStartDate,
      //             }
      //             axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //             axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //             axios.post(`/api/v1/companies/save-general-info?companyId=${this.$route.query.companyId}`, data)
      //               .then(response => {
      //                 this.notification("Success", "Edit company", "success");
      //               })
      //               .catch(error => {
      //                 console.log('An error occurred:', error);
      //               });
      //         } else {
      //           this.$notify({
      //             title: 'Notification',
      //             message: 'Enter all fields Company Address',
      //             type: 'info'
      //           });
      //         }
      //       } else {
      //         this.formGet.countryId = null
      //         this.formGet.stateId = null
      //         this.formGet.cityId = null
      //         this.formGet.postCode = null
      //         this.formGet.address = null
      //         this.formGet.address2 = null
      //         this.formGet.address3 = null
      //
      //         // let selectedRows = this.gridApi.getSelectedRows();
      //         if (this.formGet.website.length > 0) {
      //           if (this.formGet.website.slice(0, 7) != 'http://' && this.formGet.website.slice(0, 8) != 'https://') {
      //             this.formGet.website = 'http://' + this.formGet.website
      //           }
      //         }
      //
      //         let customFieldsJson = {
      //           organization: this.formGet.name,
      //           tradingName: this.formGet.tradingName,
      //           businessType: this.formGet.businessType,
      //           website: this.formGet.website,
      //           totalEmployess: this.formGet.totalEmployess,
      //           startedOn: this.formGet.startedOn,
      //           primaryPhone: this.formGet.primaryPhone,
      //           fax: this.formGet.fax,
      //         }
      //         customFieldsJson = JSON.stringify(customFieldsJson)
      //
      //         let data = {
      //           avatarUrl: this.formGet.logoUrl,
      //           name: this.formGet.name,
      //           email: this.formGet.email,
      //           currencyId: this.formGet.currencyCode,
      //           customFieldsJson: customFieldsJson,
      //           countryId: this.formGet.countryId,
      //           stateId: this.formGet.stateId,
      //           cityId: this.formGet.cityId,
      //           address: this.formGet.address,
      //           address2: this.formGet.address2,
      //           address3: this.formGet.address3,
      //           postCode: this.formGet.postCode,
      //           isAddressAssigned: this.formGet.isAddressAssigned,
      //           taxNumber: this.formGet.taxNumber,
      //           financialYearStartDate: this.formGet.financialYearStartDate,
      //         }
      //         axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //         axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //         axios.post(`/api/v1/companies/save-general-info?companyId=${this.$route.query.companyId}`, data)
      //           .then(response => {
      //             this.notification("Success", "Edit company", "success");
      //           })
      //           .catch(error => {
      //             console.log('An error occurred:', error);
      //           });
      //       }
      //     }
      //   });
      // },
      save2(form) {
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            if (!this.formGet2.website) this.formGet2.website = ''
            if (!this.formGet2.eCommerceWebsite) this.formGet2.eCommerceWebsite = ''
            // if (this.formGet2.website.length > 0) {
            //   if (this.formGet2.website.slice(0, 7) != 'http://' && this.formGet2.website.slice(0, 8) != 'https://') {
            //     this.formGet2.website = 'http://' + this.formGet2.website
            //   }
            // }
            // if (this.formGet2.eCommerceWebsite.length > 0) {
            //   if (this.formGet2.website.slice(0, 7) != 'http://' && this.formGet2.eCommerceWebsite.slice(0, 8) != 'https://') {
            //     this.formGet2.eCommerceWebsite = 'http://' + this.formGet2.eCommerceWebsite
            //   }
            // }

            let customFieldsJson = {
              tradingName: this.formGet2.tradingName,
              totalEmployess: this.formGet2.totalEmployess,
              startedOn: this.formGet2.startedOn,
              primaryPhone: this.formGet2.primaryPhone,
              fax: this.formGet2.fax,
              website: this.linkFormatting(this.formGet2.website),
              eCommerceWebsite: this.linkFormatting(this.formGet2.eCommerceWebsite),
              linkedinPage: this.linkFormatting(this.formGet2.linkedinPage),
              facebookPage: this.linkFormatting(this.formGet2.facebookPage),
              twitterAccount: this.linkFormatting(this.formGet2.twitterAccount),
              youtube: this.linkFormatting(this.formGet2.youtube),
              otherSocial: this.linkFormatting(this.formGet2.otherSocial),
              mainPostCode: this.formGet2.mainPostCode,
              postalAddress: this.formGet2.postalAddress,
              postalAddress2: this.formGet2.postalAddress2,
              postalAddress3: this.formGet2.postalAddress3,
              postalPostCode: this.formGet2.postalPostCode,
              timezoneId: this.formGet2.timezoneId,
              about: this.formGet2.about,
              entityType: this.formGet2.entityType,
              lastName: this.formGet2.entityType === 1 ? this.formGet2.lastName : '',
              firstName: this.formGet2.entityType === 1 ? this.formGet2.firstName : '',
              middleName: this.formGet2.entityType === 1 ? this.formGet2.middleName : '',
            }

            customFieldsJson = JSON.stringify(customFieldsJson)

            const payload = {
              avatarUrl: this.formGet2.logoUrl,
              name: this.formGet2.name,
              email: this.formGet2.email,
              // currencyId: this.formGet2.currencyCode,
              customFieldsJson: customFieldsJson,
              countryId: this.formGet2.countryId,
              stateId: this.formGet2.stateId,
              cityId: this.formGet2.cityId,
              address: this.formGet2.address,
              address2: this.formGet2.address2,
              address3: this.formGet2.address3,
              // postCode: this.formGet2.postCode,
              // isAddressAssigned: this.formGet2.isAddressAssigned,
              // taxNumber: this.formGet2.taxNumber,
              // financialYearStartDate: this.formGet2.financialYearStartDate,
              mainCountryId: this.formGet2.mainCountryId,
              mainStateId: this.formGet2.mainStateId,
              mainCityId: this.formGet2.mainCityId,
              postalCountryId: this.formGet2.postalCountryId,
              postalStateId: this.formGet2.postalStateId,
              postalCityId: this.formGet2.postalCityId,
              typeOfOrganisationId: this.formGet2.typeOfOrganisationId
            }

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();

            try {
              const response = await axios.post(`/api/v1/companies/save-general-info?companyId=${this.$route.query.companyId}`, payload)
              this.notification("Success", "Edit company", "success");
              console.log('response', response)
            } catch (err) {
              console.log(err)
            }

          }
        })
      },
      handleLogoSuccess( file, fileList ) {
        console.log("FILE",file);
        var formData = new FormData();
        formData.append('file', file.file);

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            console.log('---P', response.data);
            this.formGet2.logoUrl = response.data.fileUrl;
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      beforeLogoUpload(file) {
        const isImage = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/tiff', 'image/webp'].indexOf(file.type) != -1;
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isImage) {
          this.$message.error(this.$t('settings_companyAdditionalInfoError_AvatartPictureMustBeJPGFormat'));
        }
        if (!isLt2M) {
          this.$message.error(this.$t('settings_companyAdditionalInfoError_AvatartPictureSizeCanNotExeed2MB'));
        }
        return isImage && isLt2M;
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      // TODO new methods
      async changeCountry(countryId) {
        this.formGet2.stateId = null
        this.formGet2.cityId = null
        this.formGet2.typeOfOrganisationId = null
        this.arrStateId = []
        this.arrCityId = []
        this.arrtypeOfOrganisationId = []
        this.arrStateId = await this.loadList('state', countryId, 'stateList')

        this.getTypeOfOrganization(countryId)
      },
      async changeState(stateId) {
        this.formGet2.cityId = null
        this.arrCityId = []
        this.arrCityId = await this.loadList('city', stateId, 'cityList')
      },
      async changeMainCountry(countryId) {
        this.formGet2.mainStateId = null
        this.formGet2.mainCityId = null
        this.arrMainStateId = []
        this.arrMainCityId = []
        this.arrMainStateId = await this.loadList('state', countryId, 'stateList')
      },
      async changeMainState(stateId) {
        this.formGet2.mainCityId = null
        this.arrMainCityId = []
        this.arrMainCityId = await this.loadList('city', stateId, 'cityList')
      },
      async changePostalCountry(countryId) {
        this.formGet2.postalStateId = null
        this.formGet2.postalCityId = null
        this.arrPostalStateId = []
        this.arrPostalCityId = []
        this.arrPostalStateId = await this.loadList('state', countryId, 'stateList')
      },
      async changePostalState(stateId) {
        this.formGet2.postalCityId = null
        this.arrPostalCityId = []
        this.arrPostalCityId = await this.loadList('city', stateId, 'cityList')
      },
      async loadList(type, id) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const response = await axios.get(`/api/v1/country/directories?type=${type}&id=${id}`)
        loader.hide()
        return response.data.list
      },
    }
  }
</script>

<style lang="less" scoped>
.settings {
  background: #DfE8F0;
}
/deep/ .el-form-item__label {
  padding-bottom: 0 !important;
}
.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}

    .form-get{
        // width:700px;
    }
    .el-autocomplete{
        width:100%;
    }
    .company-logo-block {
      height: calc(100% - 18px);
      /deep/.el-form-item__content {
        height: 100%;
      }
    }
    /deep/ .logo-uploader {
      height: 100%;
    }
    /deep/.logo-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    /deep/.el-upload {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    /deep/.logo-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    /deep/.logo-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        line-height: 70px !important;
        text-align: center;
    }
    /deep/.logo {
        width: 200px;
        /*height:70px;*/
        display: block;
    }
</style>
